export default class CSVImportsJwtServices {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(`csv-import-reports`, {
      params
    })
  }

  create(payload) {
    return this.axiosIns.post(`csv-import-reports`, payload)
  }

  fetch(id) {
    return this.axiosIns.get(`csv-import-reports/${id}`, {})
  }

  rerun(id) {
    return this.axiosIns.post(`csv-import-reports/${id}/rerun`, {})
  }

  purge(id) {
    return this.axiosIns.post(`csv-import-reports/${id}/purge`, {})
  }

  update(id, formData) {
    return this.axiosIns.put(`csv-import-reports/${id}`, formData);
  }

  delete(id) {
    return this.axiosIns.delete(`csv-import-reports/${id}`, {})
  }

  download(reference) {
    return this.axiosIns.get(`csv-import-reports/${reference}/download`)
  }
}
